module.exports = __webpack_public_path__ + "assets/refund.a8bce0fe.svg";